import { useQuery, QueryConfig } from 'react-query'

import { useAsyncDebounce } from '../../utils/useAsyncDebounce'
import {
  useBackendContext,
  BackendQueryOptions,
  BackendError,
} from '../../components/BackendContext'

type Path<T = any> = [string, BackendQueryOptions<T>?]
type Config = { debounce?: number; humpclub?: boolean }

export type BackendPaginatedConfig<T> = Config & QueryConfig<T>

export function useBackendQuery<T>(path: Path, config: BackendPaginatedConfig<T> = {}) {
  const { humpclub, debounce, ...restConfig } = config

  const { query: coreQuery, humpclubQuery } = useBackendContext()

  const query = humpclub ? humpclubQuery : coreQuery

  const debouncedQuery = useAsyncDebounce(query, debounce)

  const _query = debounce ? debouncedQuery : query

  const _config = {
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    ...restConfig,
  }

  const response = useQuery<T, BackendError, Path>(path, _query, _config)

  return response
}

export default useBackendQuery
